import { Switch } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

export const FormSwitch = (props: any): ReactElement | null => {
  const [switchToggleValue, setSwitchToggleValue] = useState(false);
  const formConfig = useGetFormConfig(props);
  const {
    disabled,
    onChange = (event: any): any => {},
    form,
    key,
    isSwitch,
    hideToogleValue,
  } = formConfig;

  useEffect((): void => {
    if (form) {
      const formVal = form.getFieldsValue([key])[key] || false;
      setSwitchToggleValue(formVal);
    }
  }, []);

  return (
    <FormItem
      formConfig={formConfig}
      valuePropName="checked"
      isSwitch={isSwitch}
      hideToogleValue={hideToogleValue ? true : false}
      switchToggleValue={switchToggleValue}
    >
      <Switch
        data-testid={key}
        size="small"
        disabled={disabled}
        onChange={(event: any): any => {
          onChange(event);
          setSwitchToggleValue(event);
        }}
      />
    </FormItem>
  );
};

export default FormSwitch;
